import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Form, Row } from '@vivaldis/antd-ui'
import { ImageUpload } from '../../../../../../components/ImageUpload'
import { useForm } from '../../../../provider/FormProvider'

export const IdCardImages: FC = () => {
  const [t] = useTranslation('web_ui')

  const { values, setFieldError, setFieldTouched, setFieldValue } = useForm()

  return (
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          name="idCardFrontPictureFile"
          required
          label={t(
            'edit_employee_personal_information_form.steps.upload_id_card.id_card_front_picture.label'
          )}
        >
          <ImageUpload
            defaultSrc={undefined}
            fieldName={'idCardFrontPictureFile'}
            value={values.idCardFrontPictureFile}
            setFieldError={setFieldError}
            setFieldTouched={setFieldTouched}
            setFieldValue={setFieldValue}
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name="idCardBackPictureFile"
          required
          label={t(
            'edit_employee_personal_information_form.steps.upload_id_card.id_card_back_picture.label'
          )}
        >
          <ImageUpload
            defaultSrc={undefined}
            fieldName={'idCardBackPictureFile'}
            value={values.idCardBackPictureFile}
            setFieldError={setFieldError}
            setFieldTouched={setFieldTouched}
            setFieldValue={setFieldValue}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
